<div class="qr-code-container">
  <div
    class="loading-table-overlay-spinner-container"
    *ngIf="!qrCodeUrl; else qr"
  >
    <i class="fas fa-spinner fa-spin loading-table-overlay-spinner"></i>
  </div>
  <ng-template #qr><img [src]="qrCodeUrl" alt="MFA QR Code" /> </ng-template>
</div>
